module.exports = __webpack_public_path__ + "img/12.90f31e14.jpg";